module.exports = __webpack_public_path__ + "static/media/2.613c9ceb.jpg";